export { SearchResult } from './search-result';
export { LinkRouter } from './search-result';

export { BackAuthUserSearchResult } from './back-auth-user-search-result';
export { BackAuthEntitySearchResult } from './back-auth-entity-search-result';
export { BckpJobSearchResult } from './bckp-job-search-result';
export { BckpServerSearchResult } from './bckp-server-search-result';
export { Its2RequestSearchResult } from './its2-request-search-result';
export { BckpPolicySearchResult } from './bckp-policy-search-result';
export { CompInstanceSearchResult } from './comp-instance-search-result';
